import { Injectable } from '@angular/core';
import {
  ListingAttributes,
  ListingQueryParams,
} from '../../../domain/models/listing.model';

@Injectable({
  providedIn: 'root',
})
export class ListingFiltersParserUtility {
  constructor() {}

  private _buildQueryParams(params: ListingQueryParams): string {
    const queryParams = new URLSearchParams({
      start: params.start.toString(),
      end: params.end.toString(),
    });

    if (params.sortBy && params.order) {
      queryParams.append('sortBy', params.sortBy);
      queryParams.append('order', params.order);
    }

    if (params.filters) {
      Object.entries(params.filters).forEach(([key, value]) => {
        if (!value) return;

        if (key === 'attributes' && typeof value === 'object') {
          Object.entries(value as ListingAttributes).forEach(
            ([attrKey, attrValue]) => {
              if (Array.isArray(attrValue)) {
                attrValue.forEach((item) => {
                  queryParams.append(
                    `filters[attributes][${attrKey}][]`,
                    encodeURIComponent(item.toString())
                  );
                });
                return;
              }
              queryParams.append(
                `filters[attributes][${attrKey}]`,
                encodeURIComponent(attrValue.toString())
              );
            }
          );

          return;
        }

        if (Array.isArray(value)) {
          value.forEach((item) => {
            queryParams.append(
              `filters[${key}][]`,
              encodeURIComponent(item.toString())
            );
          });
          return;
        }

        queryParams.append(
          `filters[${key}]`,
          encodeURIComponent(value.toString())
        );
      });
    }
    return queryParams.toString();
  }

  toQuery(params: ListingQueryParams): string {
    return this._buildQueryParams(params);
  }

  private _parseListingQueryParamMap(params: { [key: string]: any }): {
    [key: string]: any;
  } {
    const result: { [key: string]: any } = {};

    for (const [key, value] of Object.entries(params)) {
      // Decode the key to handle URL-encoded characters

      // Split the key into parts using regex to handle nested structure
      const keys = key.split(/\[(.*?)\]/).filter(Boolean);
      // Traverse the keys and build the nested object
      let current = result;
      for (let i = 0; i < keys.length - 1; i++) {
        const currentKey = keys[i];
        if (!current[currentKey]) {
          current[currentKey] = {};
        }
        current = current[currentKey];
      }

      // Assign the value to the final key
      const finalKey = keys[keys.length - 1];
      const queryValue =
        typeof value === 'string' ? decodeURIComponent(value) : value;
      current[finalKey] = queryValue;
    }

    return result;
  }

  toListingQueryParams(queryMap: { [key: string]: any }): ListingQueryParams {
    return this._parseListingQueryParamMap(queryMap) as ListingQueryParams;
  }
}
